var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExpandGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#DDD",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144-144v-192h72v69l117-117 51 51-117 117h69v72H144Zm480 0v-72h69L576-333l51-51 117 117v-69h72v192H624ZM333-576 216-693v69h-72v-192h192v72h-69l117 117-51 51Zm294 0-51-51 117-117h-69v-72h192v192h-72v-69L627-576ZM479.79-408Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpandGroup);
export default __webpack_public_path__ + "static/media/ic_expand_group.54842fe62472826d3d71eb687d35be92.svg";
export { ForwardRef as ReactComponent };